import { makeAutoObservable } from "mobx"

export type Theme = "light" | "dark"

export class ThemeStore {
  theme: Theme = "light"

  constructor() {
    makeAutoObservable(this)
    this.loadTheme()
  }

  private loadTheme() {
    const savedTheme = localStorage.getItem("theme") as Theme | null
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches

    this.theme = savedTheme || (prefersDark ? "dark" : "light")
    this.applyTheme()

    // Listen for system theme changes
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
      if (!localStorage.getItem("theme")) {
        this.theme = e.matches ? "dark" : "light"
        this.applyTheme()
      }
    })
  }

  private applyTheme() {
    if (this.theme === "dark") {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
  }

  toggleTheme() {
    this.theme = this.theme === "light" ? "dark" : "light"
    localStorage.setItem("theme", this.theme)
    this.applyTheme()
  }

  setTheme(theme: Theme) {
    this.theme = theme
    localStorage.setItem("theme", theme)
    this.applyTheme()
  }
}
